/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pallet.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
import * as i8 from '../../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table.component.ngfactory';
import * as i9 from '@covalent/core/data-table/data-table.component';
import * as i10 from '@angular/platform-browser';
import * as i11 from '@angular/forms';
import * as i12 from '@angular/flex-layout/flexbox/api/flex';
import * as i13 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i14 from '@angular/common';
import * as i15 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i16 from '@angular/router';
import * as i17 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i18 from '@covalent/core/loading/directives/loading.directive';
import * as i19 from '@covalent/core/loading/services/loading.service';
import * as i20 from '../../../../../../app/agatextscreens/accounting/pallets/pallet/pallet.component';
import * as i21 from '../../../../../../app/shared/services/pallet.service';
import * as i22 from '@angular/http';
import * as i23 from '../../../../../../app/app.constants';
import * as i24 from '../../../../../../app/shared/services/authentication.service';
import * as i25 from '../../../../../../app/agatextscreens/inventory/inventory.service';
import * as i26 from '../../../../../../services/location.service';
import * as i27 from '@covalent/core/dialogs/services/dialog.service';
const styles_PalletComponent:any[] = [i0.styles];
export const RenderType_PalletComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PalletComponent,data:{}});
function View_PalletComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'padded-container unsaved-changes'],['fxLayout','row'],['fxLayoutGap','30px']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
      (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
      {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
      i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['warning'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n  ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'padded-container unsaved-changes';
    _ck(_v,3,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = i1.ɵunv(_v,11,0,_ck(_v,12,0,i1.ɵnov((<any>_v.parent),0),
        'you_have_unsaved_changes',_co._authService.getLanguage()));
    _ck(_v,11,0,currVal_4);
  });
}
function View_PalletComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[7,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['',' -\n              ',
          '']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_PalletComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-divider',([] as any[]),
      [[2,'mat-divider',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
      i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdListDivider,
      ([] as any[]),(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdDividerCssMatStyler,
      ([] as any[]),(null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
  });
}
function View_PalletComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),14,'div',[['class',
      'padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      8,'td-data-table',[['fxFlex','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.selectedRows = $event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i8.View_TdDataTableComponent_0,i8.RenderType_TdDataTableComponent)),i1.ɵdid(1097728,
      [['dataTable',4]],1,i9.TdDataTableComponent,[[2,i10.DOCUMENT],i1.ChangeDetectorRef],
      {data:[0,'data'],columns:[1,'columns'],selectable:[2,'selectable'],sortable:[3,
          'sortable']},(null as any)),i1.ɵqud(603979776,14,{_templates:1}),i1.ɵprd(1024,
      (null as any),i11.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i9.TdDataTableComponent]),i1.ɵdid(671744,(null as any),0,i11.NgModel,[[8,
      (null as any)],[8,(null as any)],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
      {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i11.NgControl,
      (null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),0,i11.NgControlStatus,
      [i11.NgControl],(null as any),(null as any)),i1.ɵdid(737280,(null as any),0,
      i12.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
          [3,i13.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          \n\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'row';
        const currVal_1:any = 'column';
        _ck(_v,1,0,currVal_0,currVal_1);
        const currVal_2:any = '30px';
        const currVal_3:any = '14px';
        _ck(_v,2,0,currVal_2,currVal_3);
        const currVal_4:any = 'padded-container';
        _ck(_v,3,0,currVal_4);
        const currVal_12:any = _co.itemsInPallet;
        const currVal_13:any = _co.columns;
        const currVal_14:any = false;
        const currVal_15:any = false;
        _ck(_v,6,0,currVal_12,currVal_13,currVal_14,currVal_15);
        const currVal_16:any = _co.selectedRows;
        _ck(_v,9,0,currVal_16);
        const currVal_17:any = '';
        _ck(_v,12,0,currVal_17);
      },(_ck,_v) => {
        const currVal_5:any = i1.ɵnov(_v,11).ngClassUntouched;
        const currVal_6:any = i1.ɵnov(_v,11).ngClassTouched;
        const currVal_7:any = i1.ɵnov(_v,11).ngClassPristine;
        const currVal_8:any = i1.ɵnov(_v,11).ngClassDirty;
        const currVal_9:any = i1.ɵnov(_v,11).ngClassValid;
        const currVal_10:any = i1.ɵnov(_v,11).ngClassInvalid;
        const currVal_11:any = i1.ɵnov(_v,11).ngClassPending;
        _ck(_v,5,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
      });
}
function View_PalletComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n          Total Rolls: ','\n        ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    const currVal_1:any = 'column';
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = '30px';
    const currVal_3:any = '14px';
    _ck(_v,2,0,currVal_2,currVal_3);
    const currVal_4:any = 'padded-container';
    _ck(_v,3,0,currVal_4);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_5:any = _co.itemsInPallet.length;
    _ck(_v,4,0,currVal_5);
  });
}
function View_PalletComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),73,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),58,'div',
          [['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],
              ['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '25%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i11.NgForm],[2,i11.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i12.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i13.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,26)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,26)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPallet.name = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i11.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i11.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i11.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i11.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i11.NgControl,(null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),0,
          i11.NgControlStatus,[i11.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[1,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i11.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),12,'md-select',[['name','branch'],
              ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
                  0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',
                  0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,
                  'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,35)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,35)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.branchFilter = $event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_3:any = ((<any>_co.getLocationsForBranch($event)) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i11.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,
              (null as any)]],{name:[0,'name'],isDisabled:[1,'isDisabled'],model:[2,
              'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i11.NgControl,
          (null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),0,i11.NgControlStatus,
          [i11.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(1294336,(null as any),1,i7.MdSelect,
          [i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,[2,i7.Dir],
              [2,i11.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder'],
              disabled:[1,'disabled']},(null as any)),i1.ɵqud(603979776,7,{options:1}),
      i1.ɵppd(2),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),
          0,2,(null as any),View_PalletComponent_4)),i1.ɵdid(802816,(null as any),
          0,i14.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),i1.ɵpid(131072,i14.AsyncPipe,[i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(0,['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '25%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,45)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i11.NgForm],[2,i11.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,8,{_mdInputChild:0}),i1.ɵqud(335544320,9,{_placeholderChild:0}),
      i1.ɵqud(603979776,10,{_errorChildren:1}),i1.ɵqud(603979776,11,{_hintChildren:1}),
      i1.ɵqud(603979776,12,{_prefixChildren:1}),i1.ɵqud(603979776,13,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i12.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i13.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,55)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,55).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,55)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,55)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,60)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,60)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,60)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPallet.location_name = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i11.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i11.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i11.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i11.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i11.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i11.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i11.NgControl,(null as any),[i11.NgModel]),i1.ɵdid(16384,(null as any),0,
          i11.NgControlStatus,[i11.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[8,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i11.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PalletComponent_5)),i1.ɵdid(16384,(null as any),
          0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PalletComponent_6)),i1.ɵdid(16384,(null as any),
          0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PalletComponent_7)),i1.ɵdid(16384,(null as any),
          0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        \n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'row';
    const currVal_3:any = 'column';
    _ck(_v,6,0,currVal_2,currVal_3);
    const currVal_4:any = '30px';
    const currVal_5:any = '14px';
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = 'padded-container';
    _ck(_v,8,0,currVal_6);
    const currVal_18:any = '25%';
    _ck(_v,18,0,currVal_18);
    const currVal_32:any = _co.currentPallet.name;
    _ck(_v,23,0,currVal_32);
    const currVal_33:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,26,0,_ck(_v,27,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'name',_co._authService.getLanguage())),
        '');
    _ck(_v,26,0,currVal_33);
    const currVal_50:any = 'branch';
    const currVal_51:any = (_co.itemsInPallet.length > 0);
    const currVal_52:any = _co.branchFilter;
    _ck(_v,31,0,currVal_50,currVal_51,currVal_52);
    const currVal_53:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,35,0,_ck(_v,37,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'branch',_co._authService.getLanguage())),
        '');
    const currVal_54:any = (_co.itemsInPallet.length > 0);
    _ck(_v,35,0,currVal_53,currVal_54);
    const currVal_55:any = i1.ɵunv(_v,40,0,i1.ɵnov(_v,41).transform(_co.allBranches$));
    _ck(_v,40,0,currVal_55);
    const currVal_67:any = '25%';
    _ck(_v,52,0,currVal_67);
    const currVal_81:any = _co.currentPallet.location_name;
    _ck(_v,57,0,currVal_81);
    const currVal_82:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,60,0,_ck(_v,61,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'location',_co._authService.getLanguage())),
        '');
    _ck(_v,60,0,currVal_82);
    const currVal_83:any = (_co.isEditMode && (_co.itemsInPallet.length > 0));
    _ck(_v,66,0,currVal_83);
    const currVal_84:any = (_co.isEditMode && (_co.itemsInPallet.length > 0));
    _ck(_v,69,0,currVal_84);
    const currVal_85:any = (_co.isEditMode && (_co.itemsInPallet.length > 0));
    _ck(_v,72,0,currVal_85);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_7:any = (null as any);
    const currVal_8:any = true;
    const currVal_9:any = i1.ɵnov(_v,11)._isErrorState();
    const currVal_10:any = i1.ɵnov(_v,11)._mdInputChild.focused;
    const currVal_11:any = i1.ɵnov(_v,11)._shouldForward('untouched');
    const currVal_12:any = i1.ɵnov(_v,11)._shouldForward('touched');
    const currVal_13:any = i1.ɵnov(_v,11)._shouldForward('pristine');
    const currVal_14:any = i1.ɵnov(_v,11)._shouldForward('dirty');
    const currVal_15:any = i1.ɵnov(_v,11)._shouldForward('valid');
    const currVal_16:any = i1.ɵnov(_v,11)._shouldForward('invalid');
    const currVal_17:any = i1.ɵnov(_v,11)._shouldForward('pending');
    _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17]);
    const currVal_19:any = i1.ɵnov(_v,25).ngClassUntouched;
    const currVal_20:any = i1.ɵnov(_v,25).ngClassTouched;
    const currVal_21:any = i1.ɵnov(_v,25).ngClassPristine;
    const currVal_22:any = i1.ɵnov(_v,25).ngClassDirty;
    const currVal_23:any = i1.ɵnov(_v,25).ngClassValid;
    const currVal_24:any = i1.ɵnov(_v,25).ngClassInvalid;
    const currVal_25:any = i1.ɵnov(_v,25).ngClassPending;
    const currVal_26:any = true;
    const currVal_27:any = i1.ɵnov(_v,26).id;
    const currVal_28:any = i1.ɵnov(_v,26).placeholder;
    const currVal_29:any = i1.ɵnov(_v,26).disabled;
    const currVal_30:any = i1.ɵnov(_v,26).required;
    const currVal_31:any = (i1.ɵnov(_v,26).ariaDescribedby || (null as any));
    _ck(_v,20,1,[currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
        currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31]);
    const currVal_34:any = i1.ɵnov(_v,33).ngClassUntouched;
    const currVal_35:any = i1.ɵnov(_v,33).ngClassTouched;
    const currVal_36:any = i1.ɵnov(_v,33).ngClassPristine;
    const currVal_37:any = i1.ɵnov(_v,33).ngClassDirty;
    const currVal_38:any = i1.ɵnov(_v,33).ngClassValid;
    const currVal_39:any = i1.ɵnov(_v,33).ngClassInvalid;
    const currVal_40:any = i1.ɵnov(_v,33).ngClassPending;
    const currVal_41:any = i1.ɵnov(_v,35).tabIndex;
    const currVal_42:any = i1.ɵnov(_v,35)._ariaLabel;
    const currVal_43:any = i1.ɵnov(_v,35).ariaLabelledby;
    const currVal_44:any = i1.ɵnov(_v,35).required.toString();
    const currVal_45:any = i1.ɵnov(_v,35).disabled.toString();
    const currVal_46:any = (((i1.ɵnov(_v,35)._control == null)? (null as any): i1.ɵnov(_v,
        35)._control.invalid) || 'false');
    const currVal_47:any = i1.ɵnov(_v,35)._optionIds;
    const currVal_48:any = i1.ɵnov(_v,35).disabled;
    const currVal_49:any = true;
    _ck(_v,30,1,[currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,
        currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,currVal_46,
        currVal_47,currVal_48,currVal_49]);
    const currVal_56:any = (null as any);
    const currVal_57:any = true;
    const currVal_58:any = i1.ɵnov(_v,45)._isErrorState();
    const currVal_59:any = i1.ɵnov(_v,45)._mdInputChild.focused;
    const currVal_60:any = i1.ɵnov(_v,45)._shouldForward('untouched');
    const currVal_61:any = i1.ɵnov(_v,45)._shouldForward('touched');
    const currVal_62:any = i1.ɵnov(_v,45)._shouldForward('pristine');
    const currVal_63:any = i1.ɵnov(_v,45)._shouldForward('dirty');
    const currVal_64:any = i1.ɵnov(_v,45)._shouldForward('valid');
    const currVal_65:any = i1.ɵnov(_v,45)._shouldForward('invalid');
    const currVal_66:any = i1.ɵnov(_v,45)._shouldForward('pending');
    _ck(_v,44,1,[currVal_56,currVal_57,currVal_58,currVal_59,currVal_60,currVal_61,
        currVal_62,currVal_63,currVal_64,currVal_65,currVal_66]);
    const currVal_68:any = i1.ɵnov(_v,59).ngClassUntouched;
    const currVal_69:any = i1.ɵnov(_v,59).ngClassTouched;
    const currVal_70:any = i1.ɵnov(_v,59).ngClassPristine;
    const currVal_71:any = i1.ɵnov(_v,59).ngClassDirty;
    const currVal_72:any = i1.ɵnov(_v,59).ngClassValid;
    const currVal_73:any = i1.ɵnov(_v,59).ngClassInvalid;
    const currVal_74:any = i1.ɵnov(_v,59).ngClassPending;
    const currVal_75:any = true;
    const currVal_76:any = i1.ɵnov(_v,60).id;
    const currVal_77:any = i1.ɵnov(_v,60).placeholder;
    const currVal_78:any = i1.ɵnov(_v,60).disabled;
    const currVal_79:any = i1.ɵnov(_v,60).required;
    const currVal_80:any = (i1.ɵnov(_v,60).ariaDescribedby || (null as any));
    _ck(_v,54,1,[currVal_68,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73,
        currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,currVal_79,currVal_80]);
  });
}
function View_PalletComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.create()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'create',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_PalletComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.save()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'save_data',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_PalletComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'md-card-actions',
      ([] as any[]),[[2,'mat-card-actions',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),19,'div',[['class','table-control-buttons'],['fxFlex',''],
              ['fxFlexAlign','start'],['fxFlexAlign.lt-md','center'],['fxLayoutGap',
                  '12px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i12.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i13.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i15.FlexAlignDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PalletComponent_9)),i1.ɵdid(16384,(null as any),0,i14.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PalletComponent_10)),i1.ɵdid(16384,(null as any),
          0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),6,'button',[['class','bg-red color-white mat-button'],['color',
              'warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n        ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_1:any = '12px';
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = '';
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = 'start';
    const currVal_4:any = 'center';
    _ck(_v,7,0,currVal_3,currVal_4);
    const currVal_5:any = 'table-control-buttons';
    _ck(_v,8,0,currVal_5);
    const currVal_6:boolean = !_co.isEditMode;
    _ck(_v,11,0,currVal_6);
    const currVal_7:any = _co.isEditMode;
    _ck(_v,14,0,currVal_7);
    const currVal_9:any = 'warn';
    _ck(_v,18,0,currVal_9);
    const currVal_10:any = 'bg-red color-white';
    _ck(_v,20,0,currVal_10);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_8:any = (i1.ɵnov(_v,18).disabled || (null as any));
    _ck(_v,16,0,currVal_8);
    const currVal_11:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'back',_co._authService.getLanguage()));
    _ck(_v,21,0,currVal_11);
  });
}
function View_PalletComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),45,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i6.View_MdCard_0,
      i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,29,'md-card-header',
          [['fxLayout','column']],[[2,'mat-card-header',(null as any)]],(null as any),
          (null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,16,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),11,'span',
          [['class','md-title'],['fxFlex','100']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i12.FlexDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],[3,i13.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['',' /\n            '])),i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'a',([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,19).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i16.RouterLinkWithHref,
          [i16.Router,i16.ActivatedRoute,i14.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' /\n            ','\n          '])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          ',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PalletComponent_3)),
      i1.ɵdid(16384,(null as any),0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),
          i1.ɵeld(0,(null as any),0,6,'md-card-actions',([] as any[]),[[2,'mat-card-actions',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_PalletComponent_8)),i1.ɵdid(16384,(null as any),0,i14.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,['\n    ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_2:any = 'column';
    _ck(_v,7,0,currVal_2);
    const currVal_4:any = '100';
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = 'md-title';
    _ck(_v,15,0,currVal_5);
    const currVal_9:any = _ck(_v,20,0,'../../');
    _ck(_v,19,0,currVal_9);
    const currVal_13:any = 'bg-grey color-white text-only';
    _ck(_v,30,0,currVal_13);
    const currVal_15:any = _co.currentPallet;
    _ck(_v,36,0,currVal_15);
    const currVal_17:boolean = !_co._authService.isViewer();
    _ck(_v,43,0,currVal_17);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = true;
    _ck(_v,4,0,currVal_1);
    const currVal_3:any = true;
    _ck(_v,9,0,currVal_3);
    const currVal_6:any = i1.ɵunv(_v,16,0,_ck(_v,17,0,i1.ɵnov((<any>_v.parent),0),
        'pda',_co._authService.getLanguage()));
    _ck(_v,16,0,currVal_6);
    const currVal_7:any = i1.ɵnov(_v,19).target;
    const currVal_8:any = i1.ɵnov(_v,19).href;
    _ck(_v,18,0,currVal_7,currVal_8);
    const currVal_10:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>_v.parent),0),
        'change_location',_co._authService.getLanguage()));
    _ck(_v,21,0,currVal_10);
    const currVal_11:any = ((_co.isEditMode && _co.currentPallet)? _co.currentPallet.name: i1.ɵunv(_v,
        23,0,_ck(_v,24,0,i1.ɵnov((<any>_v.parent),0),'new_pallet',_co._authService.getLanguage())));
    _ck(_v,23,0,currVal_11);
    const currVal_12:any = true;
    _ck(_v,27,0,currVal_12);
    const currVal_14:any = i1.ɵunv(_v,31,0,_ck(_v,32,0,i1.ɵnov((<any>_v.parent),0),
        'pallet_details',_co._authService.getLanguage()));
    _ck(_v,31,0,currVal_14);
    const currVal_16:any = true;
    _ck(_v,38,0,currVal_16);
  });
}
export function View_PalletComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i17.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),12,'div',[['fxLayout','column']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PalletComponent_1)),i1.ɵdid(16384,(null as any),
          0,i14.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'div',[['class','boxed-content-wrapper cards-no-gaps']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PalletComponent_2)),i1.ɵdid(212992,
          (null as any),0,i18.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
              i19.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],
              strategy:[3,'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i20.PalletComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.changed();
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = '_loading > 0';
    const currVal_4:any = 'circle';
    const currVal_5:any = 'indeterminate';
    const currVal_6:any = 'overlay';
    const currVal_7:any = 'accent';
    _ck(_v,11,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  },(null as any));
}
export function View_PalletComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-pallet',([] as any[]),
      (null as any),(null as any),(null as any),View_PalletComponent_0,RenderType_PalletComponent)),
      i1.ɵprd(512,(null as any),i21.PalletService,i21.PalletService,[i22.Http,i23.Configuration,
          i24.AuthenticationService]),i1.ɵdid(114688,(null as any),0,i20.PalletComponent,
          [i24.AuthenticationService,i19.TdLoadingService,i21.PalletService,i14.Location,
              i25.InventoryService,i26.LocationService,i16.ActivatedRoute,i16.Router,
              i27.TdDialogService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const PalletComponentNgFactory:i1.ComponentFactory<i20.PalletComponent> = i1.ɵccf('app-pallet',
    i20.PalletComponent,View_PalletComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/accounting/pallets/pallet/pallet.component.ngfactory.ts